import React from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames/bind";
import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { IconMoney } from "../../../assets/svg/logo";
import { useRecruitment } from "../../../context/RecruitmentContext";
import MobileHeader from "./components/header/MobileHeader";
import styles from "./ChatBotRecruimentMobile.module.sass";

const cx = classNames.bind(styles);

const LIST_META_FIELDS = [
  { label: "Trình độ học vấn", key: "education" },
  { label: "Số lượng cần tuyển", key: "quantity" },
  { label: "Kinh nghiệm", key: "experience" },
];

const JobCard = ({ campaign, onClick }) => (
  <div className={cx("jobCard")} onClick={onClick} role="button" tabIndex={0}>
    <h3 className={cx("jobCardTitle")}>{campaign.title}</h3>
    <p className={cx("jobCardDepartment")}>{campaign.department}</p>
    <div className={cx("jobCardMeta")}>
      {LIST_META_FIELDS.map((field) => (
        <div key={field.key} className={cx("metaLine")}>
          <span>{field.label}</span>
          <strong>{campaign[field.key] ?? "—"}</strong>
        </div>
      ))}
    </div>
    <div className={cx("salaryBadge")}>
      <IconMoney />
      {campaign.salaryRange}
    </div>
  </div>
);

const MobileCampaignList = () => {
  const navigate = useNavigate();
  const {
    campaigns,
    loading,
    searchInput,
    setSearchInput,
    handleSearch,
    requestChatAccess,
    isCandidateRegistered,
    enterCampaignFromList,
  } = useRecruitment();

  const handleOpenCampaign = (campaignId) => {
    enterCampaignFromList(campaignId);
    navigate(`/${campaignId}`);
  };

  const handleOpenChat = () => {
    if (requestChatAccess(null)) {
      navigate("/chat");
    }
  };

  return (
    <div className={cx("page")}>
      <MobileHeader showChatCta onChatClick={handleOpenChat} />
      <div className={cx("searchRow")} style={{ margin: "0px" }}>
        <Input
          className={cx("searchInput")}
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          placeholder="Tìm kiếm vị trí"
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          allowClear
        />
        <Button
          type="primary"
          className={cx("searchButton")}
          icon={<SearchOutlined />}
          onClick={handleSearch}
        />
      </div>
      {/* <h2 className={cx("listTitle")}>Danh sách tuyển dụng</h2> */}
      <div className={cx("listBody")}>
        {loading ? (
          <div className={cx("emptyState")}>
            <p>Đang tải danh sách vị trí...</p>
          </div>
        ) : campaigns.length > 0 ? (
          campaigns.map((item) => (
            <JobCard
              key={item.id}
              campaign={item}
              onClick={() => handleOpenCampaign(item.id)}
            />
          ))
        ) : (
          <div className={cx("emptyState")}>
            <p>Không tìm thấy vị trí phù hợp với bộ lọc.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileCampaignList;
